import NAME from "./constants";

export const GET_LOANS_ROWS = NAME + "/GET_LOANS_ROWS";
export const GET_LOANS_ROWS_FULFILLED = NAME + "/GET_LOANS_ROWS_FULFILLED";
export const GET_LOANS_ROWS_REJECTED = NAME + "/GET_LOANS_ROWS_REJECTED";

export const GET_LOANS_DETAIL = NAME + "/GET_LOANS_DETAIL";
export const GET_LOANS_DETAIL_FULFILLED = NAME + "/GET_LOANS_DETAIL_FULFILLED";
export const GET_LOANS_DETAIL_REJECTED = NAME + "/GET_LOANS_DETAIL_REJECTED";